import styled from "styled-components";

export const CustomTabsStyled = styled.div`
padding: 8px 36px;
box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
clip-path: inset(0 -10px -10px -10px);
  button {
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    /* background-color: #AF81B9; */
    color: #301d35;
    opacity: 1;
    border-radius: 4px;
  }

  .Mui-selected {
    background-color: #efedfd;
    color: #080425;
  }

`;
